import httpCommon from "./http-common";

const getDataUsingDateRange = (section: string, startYear: number, startMonth: number, startDay: number, endYear: number, endMonth: number, endDay: number) => {
  return httpCommon.get(`/v1/getDataUsingDateRange/${section}/${startYear}/${startMonth}/${startDay}/${endYear}/${endMonth}/${endDay}`);
};

const getDataUsingDateRangeWithSectionId = (section: string, sectionId: number, startYear: number, startMonth: number, startDay: number, endYear: number, endMonth: number, endDay: number) => {
  return httpCommon.get(`/v1/getDataUsingDateRange/${section}/${sectionId}/${startYear}/${startMonth}/${startDay}/${endYear}/${endMonth}/${endDay}`);
};


const DataRangeService = {
  getDataUsingDateRange,
  getDataUsingDateRangeWithSectionId
};

export default DataRangeService;
